export default __webpack_public_path__ + "static/media/success.ca6817f2.svg";